<template>
  <section class="explainer" id="begrippen">
    <div class="container">
      <div class="section-header">
        <span class="tag">{{ t('explainer.tag') }}</span>
        <h2 class="serif">{{ t('explainer.title') }}</h2>
        <p>{{ t('explainer.subtitle') }}</p>
      </div>

      <div class="explain-cards">
        <div class="explain-card" data-reveal>
          <span class="term">{{ t('explainer.term1.term') }}</span>
          <h3>{{ t('explainer.term1.title') }}</h3>
          <p>{{ t('explainer.term1.desc') }}</p>
        </div>
        <div class="explain-card" data-reveal>
          <span class="term">{{ t('explainer.term2.term') }}</span>
          <h3 v-html="t('explainer.term2.title')"></h3>
          <p>{{ t('explainer.term2.desc') }}</p>
        </div>
        <div class="explain-card" data-reveal>
          <span class="term">{{ t('explainer.term3.term') }}</span>
          <h3>{{ t('explainer.term3.title') }}</h3>
          <p>{{ t('explainer.term3.desc') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

const { t } = useLocale()
</script>

<style scoped>
.explainer { padding: 100px 0 80px; }
@media (max-width: 768px) { .explainer { padding: 48px 0 40px; } }
.section-header { text-align: center; margin-bottom: 64px; }
.section-header .tag {
  display: inline-block;
  background: var(--ink);
  color: var(--bg);
  padding: 6px 16px;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-bottom: 24px;
  border-radius: 999px;
}
.section-header h2 {
  font-size: clamp(40px, 6vw, 72px);
  font-weight: 800;
  line-height: 0.98;
  letter-spacing: -0.03em;
  margin-bottom: 20px;
}
.section-header p {
  font-size: 18px;
  color: var(--ink-soft);
  max-width: 78ch;
  margin: 0 auto;
}

.explain-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  max-width: 1000px;
  margin: 0 auto;
}
.explain-card {
  background: var(--bg-card);
  border: 1px solid var(--line-soft);
  padding: 36px 32px;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s;
}
.explain-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-hover);
}
.explain-card .term {
  display: inline-block;
  background: var(--accent-light);
  color: var(--ink);
  padding: 6px 12px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 11px;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}
.explain-card h3 {
  font-family: 'Fraunces', serif;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 12px;
  letter-spacing: -0.025em;
}
.explain-card p {
  font-size: 16px;
  color: var(--ink-soft);
  line-height: 1.6;
  min-height: 6lh;
  margin: 0;
}
</style>
